// extracted by mini-css-extract-plugin
module.exports = {"pair":"PairOfInfoItems_pair__1HXTk","centered":"PairOfInfoItems_centered__7XNYw","info":"PairOfInfoItems_info__og8rE"};